import styled from 'styled-components'

import {media as _media, H4, H1} from '@modifi/ui'

type mediaType = Record<string, any>

const media = _media as mediaType

export const StyledH4 = styled(H4)`
  ${media.max.md`
    font-size: 18px;
  `}
`

export const StyledH1 = styled(H1)`
  ${media.max.md`
    font-size: 32px !important;
  `}
`
